import React, { useEffect } from 'react';
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/Home";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminMenu from "./pages/AdminMenu";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";
import CookiePolicy from "./pages/CookiePolicy";
import ConsumerInfo from "./pages/ConsumerInfo";
import CookieBanner from "./components/CookieBanner";

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('adminToken');
  if (!token) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
};

// Component to handle global script injection cleanly inside the Router context if needed,
// but we can just do it in App component.
const GlobalFogyasztoBarat = () => {
  useEffect(() => {
    const hostname = window.location.hostname;
    if (hostname === 'akonyhad.hu' || hostname === 'www.akonyhad.hu') {
      if (document.getElementById("fbarat") === null) {
        // Create the anchor element
        if (!document.getElementById("barat_hud_sr_script")) {
          const dummy = document.createElement("script");
          dummy.id = "barat_hud_sr_script";
          document.body.appendChild(dummy);
        }
        
        const hst = document.createElement("script");
        hst.src = "//admin.fogyasztobarat.hu/h-api.js";
        hst.type = "text/javascript";
        hst.setAttribute("data-id", "63V3CLSM");
        hst.setAttribute("id", "fbarat");
        
        const hs = document.getElementById("barat_hud_sr_script");
        if (hs && hs.parentNode) {
          hs.parentNode.insertBefore(hst, hs);
        }
      }
    } else {
      console.log("[Preview Mode] Global Fogyasztó Barát HUD skipped.");
    }
  }, []);
  
  return null;
}

function App() {
  return (
    <div className="App flex flex-col min-h-screen">
      <BrowserRouter>
        <GlobalFogyasztoBarat />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/adatkezelesi-tajekoztato" element={<PrivacyPolicy />} />
          <Route path="/aszf" element={<TermsAndConditions />} />
          <Route path="/cookie-tajekoztato" element={<CookiePolicy />} />
          <Route path="/fogyasztobarat" element={<ConsumerInfo />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route 
            path="/admin/dashboard" 
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/menu" 
            element={
              <ProtectedRoute>
                <AdminMenu />
              </ProtectedRoute>
            } 
          />
        </Routes>
        <CookieBanner />
      </BrowserRouter>
    </div>
  );
}

export default App;
